export enum EventInvitationStatus {
  STATUS_NOT_INVITED = 0,
  STATUS_REJECTED = 1,
  STATUS_WAITING_FOR_APPROVAL = 2,
  STATUS_ACCEPTED = 3,
}
